// Recovered compiled webpack factory 49781. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  let n, a;
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "hydrate", {
      enumerable: !0,
      get: function () {
        return k;
      },
    }));
  let o = r(28140),
    i = r(49417),
    s = r(95155);
  r(66001);
  let l = o._(r(12669)),
    u = i._(r(12115)),
    c = r(77197),
    f = r(82073),
    d = r(3789),
    p = r(65444),
    h = r(41209),
    _ = r(85153),
    m = r(11807),
    g = o._(r(17297)),
    y = r(62592);
  r(46752);
  let v = r(3201),
    b = c.createFromReadableStream,
    E = document,
    R = new TextEncoder(),
    P = !1,
    S = !1,
    O = null;
  function T(e) {
    if (0 === e[0]) n = [];
    else if (1 === e[0]) {
      if (!n)
        throw Object.defineProperty(
          Error("Unexpected server data: missing bootstrap script."),
          "__NEXT_ERROR_CODE",
          { value: "E18", enumerable: !1, configurable: !0 },
        );
      a ? a.enqueue(R.encode(e[1])) : n.push(e[1]);
    } else if (2 === e[0]) O = e[1];
    else if (3 === e[0]) {
      if (!n)
        throw Object.defineProperty(
          Error("Unexpected server data: missing bootstrap script."),
          "__NEXT_ERROR_CODE",
          { value: "E18", enumerable: !1, configurable: !0 },
        );
      let r = atob(e[1]),
        o = new Uint8Array(r.length);
      for (var t = 0; t < r.length; t++) o[t] = r.charCodeAt(t);
      a ? a.enqueue(o) : n.push(o);
    }
  }
  let w = function () {
    (a && !S && (a.close(), (S = !0), (n = void 0)), (P = !0));
  };
  "loading" === document.readyState
    ? document.addEventListener("DOMContentLoaded", w, !1)
    : setTimeout(w);
  let j = (self.__next_f = self.__next_f || []);
  (j.forEach(T), (j.push = T));
  let x = b(
    new ReadableStream({
      start(e) {
        (n &&
          (n.forEach((t) => {
            e.enqueue("string" == typeof t ? R.encode(t) : t);
          }),
          P && !S) &&
          (null === e.desiredSize || e.desiredSize < 0
            ? e.error(
                Object.defineProperty(
                  Error(
                    "The connection to the page was unexpectedly closed, possibly due to the stop button being clicked, loss of Wi-Fi, or an unstable internet connection.",
                  ),
                  "__NEXT_ERROR_CODE",
                  { value: "E117", enumerable: !1, configurable: !0 },
                ),
              )
            : e.close(),
          (S = !0),
          (n = void 0)),
          (a = e));
      },
    }),
    { callServer: h.callServer, findSourceMapURL: _.findSourceMapURL },
  );
  function A(e) {
    let { pendingActionQueue: t } = e,
      r = (0, u.use)(x),
      n = (0, u.use)(t);
    return (0, s.jsx)(g.default, { actionQueue: n, globalErrorState: r.G, assetPrefix: r.p });
  }
  let C = u.default.StrictMode;
  function M(e) {
    let { children: t } = e;
    return t;
  }
  let N = {
    onDefaultTransitionIndicator: function () {
      return () => {};
    },
    onRecoverableError: d.onRecoverableError,
    onCaughtError: p.onCaughtError,
    onUncaughtError: p.onUncaughtError,
  };
  function k(e) {
    let t = new Promise((t, r) => {
        x.then(
          (r) => {
            (0, v.setAppBuildId)(r.b);
            let n = Date.now();
            t(
              (0, m.createMutableActionQueue)(
                (0, y.createInitialRouterState)({
                  navigatedAt: n,
                  initialFlightData: r.f,
                  initialCanonicalUrlParts: r.c,
                  initialParallelRoutes: new Map(),
                  location: window.location,
                  couldBeIntercepted: r.i,
                  postponed: r.s,
                  prerendered: r.S,
                }),
                e,
              ),
            );
          },
          (e) => r(e),
        );
      }),
      r = (0, s.jsx)(C, {
        children: (0, s.jsx)(f.HeadManagerContext.Provider, {
          value: { appDir: !0 },
          children: (0, s.jsx)(M, { children: (0, s.jsx)(A, { pendingActionQueue: t }) }),
        }),
      });
    "__next_error__" === document.documentElement.id
      ? l.default.createRoot(E, N).render(r)
      : u.default.startTransition(() => {
          l.default.hydrateRoot(E, r, { ...N, formState: O });
        });
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
